"use client"
import { features } from '@/data/site-data'
import { motion } from 'framer-motion'

export default function About() {
    return (
        <>
            <div className="w-full border-y h-8 bg-muted/10 hidden md:block opacity-50 mb-20" />
            <motion.div
                className="w-full h-full lg:py-[10svh] py-20  relative flex items-center justify-center"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
            >
                <div className='shadow-2xl w-[90%] overflow-hidden max-w-5xl bg-muted z-20 rounded-xl'>
                    <div className='w-full h-12 shadow shadow-white/5 bg-background px-5 gap-2 flex items-center justify-start'>
                        <div className='h-3.5 w-3.5 bg-red-500 rounded-full opacity-100' />
                        <div className='h-3.5 w-3.5 bg-amber-500 rounded-full opacity-100' />
                        <div className='h-3.5 w-3.5 bg-green-500 rounded-full opacity-100' />
                        <p className='ml-3 font-light text-sm'>
                            <span className='opacity-70'>https://</span>
                            lymoun.agency
                        </p>
                    </div>
                    <div className='relative w-full h-full flex items-center justify-center bg-background/50 p-5'>
                        <motion.div
                            className="w-full py-7 lg:py-20 m-auto flex flex-col justify-center items-center"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                        >
                            <motion.h2
                                className="text-2xl md:text-4xl lg:text-5xl font-bold mb-10 font-brand text-center tracking-wide"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
                            >
                                Why Choose Lymoun?
                            </motion.h2>
                            <motion.ul className="w-full grid grid-cols-1 sm:grid-cols-2 gap-2 max-w-3xl mx-auto">
                                {features.map((feature: string, i: number) => (
                                    <motion.li
                                        key={feature}
                                        className="flex items-center gap-3 p-4 rounded-xl bg-background/70 shadow font-light text-foreground/90 tracking-[-0.5px]"
                                        initial={{ opacity: 0, y: 25, filter: "blur(8px)" }}
                                        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                        viewport={{ once: true }}
                                        transition={{ duration: 0.5, delay: 0.15 + i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                                    >
                                        <img
                                            src="/svg/logo.svg"
                                            className="absolute h-8 animate-spin [animation-duration:4s] blur opacity-40"
                                        />
                                        <img
                                            src="/svg/logo.svg"
                                            className="absolute h-8 animate-spin [animation-duration:4s]"
                                        />
                                        <span className='pl-11'>{feature}</span>
                                    </motion.li>
                                ))}
                            </motion.ul>
                        </motion.div>


                    </div>
                </div>
                <video src="/videos/11.mp4" autoPlay loop muted playsInline className="object-cover h-full w-full absolute opacity-60" style={{ display: 'block', mixBlendMode: 'screen' }} />
                <div className="absolute h-full w-full bg-linear-to-b to-background via-background/40 from-background" />
                {/* <div className="absolute h-full w-full bg-linear-to-l to-background via-background/40 from-background" /> */}
            </motion.div>
            <div className="w-full border-y h-8 bg-muted/10 hidden md:block mb-50 opacity-50 mt-20" />

        </>
    )
}